<template>
  <div class="line" :style="{ ...props.style }"></div>
</template>

<script lang="ts" setup>
const props = defineProps({
  style: {
    // 下拉区域始终为全屏的高度
    type: Array,
    default: () => {}
  }
})
</script>

<style scoped lang="less">
.line {
  height: 1px;
  background: rgba(220, 222, 225, 0.6);
}
</style>
